export default __webpack_public_path__ + "static/media/bc-first.12eae5f7.svg";